import { ModuleFE_AdvisorSession } from '@app/advisor-frontend';
import { ModuleFE_BaseAdvisorRuntime } from '@app/advisor-frontend/modules/ModuleFE_BaseAdvisorRuntime';
import { DBDef_RuntimePertinentData } from '@app/advisor-v5-shared';
import { ThunderDispatcherV3 } from '@nu-art/thunderstorm-frontend/core/db-api-gen/types';
export const dispatch_onRuntimePertinentDataUpdated = new ThunderDispatcherV3('__onRuntimePertinentDataUpdated');
class ModuleFE_RuntimePertinentData_Class extends ModuleFE_BaseAdvisorRuntime {
    constructor() {
        super(DBDef_RuntimePertinentData, dispatch_onRuntimePertinentDataUpdated);
    }
    init() {
        super.init();
        this.setCacheFilter(ModuleFE_AdvisorSession.encounterFilter);
    }
}
export const ModuleFE_RuntimePertinentData = new ModuleFE_RuntimePertinentData_Class();
//# sourceMappingURL=ModuleFE_RuntimePertinentData.js.map